import Immutable from 'immutable';

export function getLiveEventIds(box) {
    return box.get('liveSportEventIds', Immutable.List());
}

export function isEmpty(box) {
    return (
        box.get('prematchHierarchy', Immutable.List()).isEmpty() &&
        box.get('resultBetsHierarchy', Immutable.List()).isEmpty() &&
        box.get('liveSportEventIds', Immutable.List()).isEmpty()
    );
}

export function isNotEmpty(box) {
    return !isEmpty(box);
}

export function isVisible(box) {
    return !box.getIn(['behavior', 'hideIfEmpty'], false) || isNotEmpty(box);
}

export function hasNoSection(box) {
    const noResults = getResultBetsHierarchy(box).isEmpty();
    const noLive = getLiveEventIds(box).isEmpty();
    const noPrematch =
        getPrematchHierarchy(box).isEmpty() && box.getIn(['selectedMarketIds'], Immutable.List()).isEmpty();
    return noResults && noLive && noPrematch;
}

export function getPrematchHierarchy(box) {
    return box ? box.get('prematchHierarchy', Immutable.List()) : Immutable.List();
}

export function getResultBetsHierarchy(box) {
    return box ? box.get('resultBetsHierarchy', Immutable.List()) : Immutable.List();
}

export function isShowMarkets(box) {
    return box.getIn(['behavior', 'showMarkets']);
}

export function isCustomBox(box) {
    return box.getIn(['behavior', 'customBox']);
}

export function getShortcutMarketIds(box) {
    return box ? box.getIn(['marketHierarchy', 'shortcut'], Immutable.List()) : Immutable.List();
}

export function hasLeagueTables(box) {
    return box.get('statisticsId') && !box.get('special');
}

export function boxMarketStatus(box) {
    const prematchHierarchy = getPrematchHierarchy(box);
    const shortcutMarketIds = getShortcutMarketIds(box);
    const customBox = isCustomBox(box);
    if (prematchHierarchy.size === 0) {
        if (shortcutMarketIds.size === 0 || customBox) {
            return 'NONE';
        }
        if (shortcutMarketIds.size > 0) {
            return 'SELECT_ANOTHER_MARKET';
        }
    }
    return 'OK';
}
